import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HtmlUtilsService {

  /**
   * Elimina un <img> al inicio del contenido HTML, si existe.
   */
  removeLeadingImage(html: string): string {
    if (!html) return '';

    const trimmed = html.trim();

    if (trimmed.startsWith('<img')) {
      const closingIndex = trimmed.indexOf('>');

      if (closingIndex !== -1) {
        return trimmed.slice(closingIndex + 1).trim();
      }
    }

    return html;
  }
}
